
<p-slider id="{{ uid }}" [(ngModel)]="value" [min]="min" [max]="max" [step]="step" [orientation]="orientation"
    (onChange)="onInputChange()" [disabled]="isDisabled" [attr.data-testid]="uid"></p-slider>